import { render, staticRenderFns } from "./CourseBuilderLearningActivity.vue?vue&type=template&id=00a27f90&scoped=true&"
import script from "./CourseBuilderLearningActivity.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderLearningActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a27f90",
  null
  
)

export default component.exports